"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { useState, useContext } from 'react';
import { DropdownStackContext } from './use-dropdown-stack.mjs';

const DropdownStackContextProvider = ({
  children,
  editorRef
}) => {
  const [stack, setStack] = useState([]);
  const {
    isNested: hasNestedDropdownsContext,
    stack: parentStack,
    setStack: setParentStack
  } = useContext(DropdownStackContext);
  if (hasNestedDropdownsContext) {
    return /* @__PURE__ */ jsx(
      DropdownStackContext.Provider,
      {
        value: {
          isNested: true,
          stack: parentStack,
          setStack: setParentStack,
          editorRef
        },
        children
      }
    );
  }
  return /* @__PURE__ */ jsx(
    DropdownStackContext.Provider,
    {
      value: {
        isNested: true,
        stack,
        setStack,
        editorRef
      },
      children
    }
  );
};

export { DropdownStackContextProvider };
